import { render, staticRenderFns } from "./CategoryCardCarouselDescription.vue?vue&type=template&id=e189e6ce&scoped=true"
import script from "./CategoryCardCarouselDescription.vue?vue&type=script&lang=ts"
export * from "./CategoryCardCarouselDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e189e6ce",
  null
  
)

export default component.exports